import AfghanistanFlag from "../assets/images/flags/af.svg";
import AlbaniaFlag from "../assets/images/flags/al.svg";
import AlgeriaFlag from "../assets/images/flags/dz.svg";
import AndorraFlag from "../assets/images/flags/ad.svg";
import AngolaFlag from "../assets/images/flags/ao.svg";
import AntiguaAndBarbudaFlag from "../assets/images/flags/ag.svg";
import ArgentinaFlag from "../assets/images/flags/ar.svg";
import ArmeniaFlag from "../assets/images/flags/am.svg";
import AustraliaFlag from "../assets/images/flags/au.svg";
import AustriaFlag from "../assets/images/flags/at.svg";
import AzerbaijanFlag from "../assets/images/flags/az.svg";
import BahamasFlag from "../assets/images/flags/bs.svg";
import BahrainFlag from "../assets/images/flags/bh.svg";
import BangladeshFlag from "../assets/images/flags/bd.svg";
import BarbadosFlag from "../assets/images/flags/bb.svg";
import BelarusFlag from "../assets/images/flags/by.svg";
import BelgiumFlag from "../assets/images/flags/be.svg";
import BelizeFlag from "../assets/images/flags/bz.svg";
import BeninFlag from "../assets/images/flags/bj.svg";
import BhutanFlag from "../assets/images/flags/bt.svg";
import BoliviaFlag from "../assets/images/flags/bo.svg";
import BosniaAndHerzegovinaFlag from "../assets/images/flags/ba.svg";
import BotswanaFlag from "../assets/images/flags/bw.svg";
import BrazilFlag from "../assets/images/flags/br.svg";
import BruneiFlag from "../assets/images/flags/bn.svg";
import BulgariaFlag from "../assets/images/flags/bg.svg";
import BurkinaFasoFlag from "../assets/images/flags/bf.svg";
import BurundiFlag from "../assets/images/flags/bi.svg";
import CaboVerdeFlag from "../assets/images/flags/cv.svg";
import CambodiaFlag from "../assets/images/flags/km.svg";
import CameroonFlag from "../assets/images/flags/cm.svg";
import CanadaFlag from "../assets/images/flags/ca.svg";
import CentralAfricanRepublicFlag from "../assets/images/flags/cf.svg";
import ChadFlag from "../assets/images/flags/td.svg";
import ChileFlag from "../assets/images/flags/cl.svg";
import ChinaFlag from "../assets/images/flags/cn.svg";
import ColombiaFlag from "../assets/images/flags/co.svg";
import ComorosFlag from "../assets/images/flags/km.svg";
import CongoFlag from "../assets/images/flags/cg.svg";
import CostaRicaFlag from "../assets/images/flags/cr.svg";
import CroatiaFlag from "../assets/images/flags/hr.svg";
import CubaFlag from "../assets/images/flags/cu.svg";
import CyprusFlag from "../assets/images/flags/cy.svg";
import CzechRepublicFlag from "../assets/images/flags/cz.svg";
import DenmarkFlag from "../assets/images/flags/dk.svg";
import DjiboutiFlag from "../assets/images/flags/dj.svg";
import DominicaFlag from "../assets/images/flags/dm.svg";
import DominicanRepublicFlag from "../assets/images/flags/do.svg";
import EastTimorFlag from "../assets/images/flags/tl.svg";
import EcuadorFlag from "../assets/images/flags/ec.svg";
import EgyptFlag from "../assets/images/flags/eg.svg";
import ElSalvadorFlag from "../assets/images/flags/sv.svg";
import EquatorialGuineaFlag from "../assets/images/flags/gq.svg";
import EritreaFlag from "../assets/images/flags/er.svg";
import EstoniaFlag from "../assets/images/flags/ee.svg";
import EswatiniFlag from "../assets/images/flags/sz.svg";
import EthiopiaFlag from "../assets/images/flags/et.svg";
import FijiFlag from "../assets/images/flags/fj.svg";
import FinlandFlag from "../assets/images/flags/fi.svg";
import FranceFlag from "../assets/images/flags/fr.svg";
import GabonFlag from "../assets/images/flags/ga.svg";
import GambiaFlag from "../assets/images/flags/gb.svg";
import GeorgiaFlag from "../assets/images/flags/ge.svg";
import GermanyFlag from "../assets/images/flags/de.svg";
import GhanaFlag from "../assets/images/flags/gh.svg";
import GreeceFlag from "../assets/images/flags/gr.svg";
import GrenadaFlag from "../assets/images/flags/gd.svg";
import GuatemalaFlag from "../assets/images/flags/gt.svg";
import GuineaFlag from "../assets/images/flags/gn.svg";
import GuineaBissauFlag from "../assets/images/flags/gw.svg";
import GuyanaFlag from "../assets/images/flags/gy.svg";
import HaitiFlag from "../assets/images/flags/ht.svg";
import HondurasFlag from "../assets/images/flags/hn.svg";
import HungaryFlag from "../assets/images/flags/hu.svg";
import IcelandFlag from "../assets/images/flags/is.svg";
import IndiaFlag from "../assets/images/flags/in.svg";
import IndonesiaFlag from "../assets/images/flags/id.svg";
import IranFlag from "../assets/images/flags/ir.svg";
import IraqFlag from "../assets/images/flags/iq.svg";
import IrelandFlag from "../assets/images/flags/ie.svg";
import IsraelFlag from "../assets/images/flags/il.svg";
import ItalyFlag from "../assets/images/flags/it.svg";
import JamaicaFlag from "../assets/images/flags/jm.svg";
import JapanFlag from "../assets/images/flags/jp.svg";
import JordanFlag from "../assets/images/flags/jo.svg";
import KazakhstanFlag from "../assets/images/flags/kz.svg";
import KenyaFlag from "../assets/images/flags/ke.svg";
import KiribatiFlag from "../assets/images/flags/ki.svg";
import KoreaNorthFlag from "../assets/images/flags/kp.svg";
import KoreaSouthFlag from "../assets/images/flags/kr.svg";
import KosovoFlag from "../assets/images/flags/xk.svg";
import KuwaitFlag from "../assets/images/flags/kw.svg";
import KyrgyzstanFlag from "../assets/images/flags/kg.svg";
import LaosFlag from "../assets/images/flags/la.svg";
import LatviaFlag from "../assets/images/flags/lv.svg";
import LebanonFlag from "../assets/images/flags/lb.svg";
import LesothoFlag from "../assets/images/flags/ls.svg";
import LiberiaFlag from "../assets/images/flags/lr.svg";
import LibyaFlag from "../assets/images/flags/ly.svg";
import LiechtensteinFlag from "../assets/images/flags/li.svg";
import LithuaniaFlag from "../assets/images/flags/lt.svg";
import LuxembourgFlag from "../assets/images/flags/lu.svg";
import MadagascarFlag from "../assets/images/flags/mg.svg";
import MalawiFlag from "../assets/images/flags/mw.svg";
import MalaysiaFlag from "../assets/images/flags/my.svg";
import MaldivesFlag from "../assets/images/flags/mv.svg";
import MaliFlag from "../assets/images/flags/ml.svg";
import MaltaFlag from "../assets/images/flags/mt.svg";
import MarshallIslandsFlag from "../assets/images/flags/mh.svg";
import MauritaniaFlag from "../assets/images/flags/mr.svg";
import MauritiusFlag from "../assets/images/flags/mu.svg";
import MexicoFlag from "../assets/images/flags/mx.svg";
import MicronesiaFlag from "../assets/images/flags/fm.svg";
import MoldovaFlag from "../assets/images/flags/md.svg";
import MonacoFlag from "../assets/images/flags/mc.svg";
import MongoliaFlag from "../assets/images/flags/mn.svg";
import MontenegroFlag from "../assets/images/flags/me.svg";
import MoroccoFlag from "../assets/images/flags/ma.svg";
import MozambiqueFlag from "../assets/images/flags/mz.svg";
import MyanmarFlag from "../assets/images/flags/mm.svg";
import NamibiaFlag from "../assets/images/flags/na.svg";
import NauruFlag from "../assets/images/flags/nr.svg";
import NepalFlag from "../assets/images/flags/np.svg";
import NetherlandsFlag from "../assets/images/flags/nl.svg";
import NewZealandFlag from "../assets/images/flags/nz.svg";
import NicaraguaFlag from "../assets/images/flags/ni.svg";
import NigerFlag from "../assets/images/flags/ne.svg";
import NigeriaFlag from "../assets/images/flags/ng.svg";
import NorthMacedoniaFlag from "../assets/images/flags/mk.svg";
import NorwayFlag from "../assets/images/flags/no.svg";
import OmanFlag from "../assets/images/flags/om.svg";
import PakistanFlag from "../assets/images/flags/pk.svg";
import PalauFlag from "../assets/images/flags/pw.svg";
import PanamaFlag from "../assets/images/flags/pa.svg";
import PapuaNewGuineaFlag from "../assets/images/flags/pg.svg";
import ParaguayFlag from "../assets/images/flags/py.svg";
import PeruFlag from "../assets/images/flags/pe.svg";
import PhilippinesFlag from "../assets/images/flags/ph.svg";
import PolandFlag from "../assets/images/flags/pl.svg";
import PortugalFlag from "../assets/images/flags/pt.svg";
import QatarFlag from "../assets/images/flags/qa.svg";
import RomaniaFlag from "../assets/images/flags/ro.svg";
import RussiaFlag from "../assets/images/flags/ru.svg";
import RwandaFlag from "../assets/images/flags/rw.svg";
import SaintKittsAndNevisFlag from "../assets/images/flags/kn.svg";
import SaintLuciaFlag from "../assets/images/flags/lc.svg";
import SaintVincentAndTheGrenadinesFlag from "../assets/images/flags/vc.svg";
import SamoaFlag from "../assets/images/flags/ws.svg";
import SanMarinoFlag from "../assets/images/flags/sm.svg";
import SaoTomeAndPrincipeFlag from "../assets/images/flags/st.svg";
import SaudiArabiaFlag from "../assets/images/flags/sa.svg";
import SenegalFlag from "../assets/images/flags/sn.svg";
import SerbiaFlag from "../assets/images/flags/rs.svg";
import SeychellesFlag from "../assets/images/flags/sc.svg";
import SierraLeoneFlag from "../assets/images/flags/sl.svg";
import SingaporeFlag from "../assets/images/flags/sg.svg";
import SlovakiaFlag from "../assets/images/flags/sk.svg";
import SloveniaFlag from "../assets/images/flags/si.svg";
import SolomonIslandsFlag from "../assets/images/flags/sb.svg";
import SomaliaFlag from "../assets/images/flags/so.svg";
import SouthAfricaFlag from "../assets/images/flags/za.svg";
import SouthSudanFlag from "../assets/images/flags/ss.svg";
import SpainFlag from "../assets/images/flags/es.svg";
import SriLankaFlag from "../assets/images/flags/lk.svg";
import SudanFlag from "../assets/images/flags/sd.svg";
import SurinameFlag from "../assets/images/flags/sr.svg";
import SwedenFlag from "../assets/images/flags/se.svg";
import SwitzerlandFlag from "../assets/images/flags/ch.svg";
import SyriaFlag from "../assets/images/flags/sy.svg";
import TaiwanFlag from "../assets/images/flags/tw.svg";
import TajikistanFlag from "../assets/images/flags/tj.svg";
import TanzaniaFlag from "../assets/images/flags/tz.svg";
import ThailandFlag from "../assets/images/flags/th.svg";
import TogoFlag from "../assets/images/flags/tg.svg";
import TongaFlag from "../assets/images/flags/to.svg";
import TrinidadAndTobagoFlag from "../assets/images/flags/tt.svg";
import TunisiaFlag from "../assets/images/flags/tn.svg";
import TurkeyFlag from "../assets/images/flags/tr.svg";
import TurkmenistanFlag from "../assets/images/flags/tm.svg";
import TuvaluFlag from "../assets/images/flags/tv.svg";
import UgandaFlag from "../assets/images/flags/ug.svg";
import UkraineFlag from "../assets/images/flags/ua.svg";
import UnitedArabEmiratesFlag from "../assets/images/flags/ae.svg";
import UnitedKingdomFlag from "../assets/images/flags/gb.svg";
import UnitedStatesFlag from "../assets/images/flags/us.svg";
import UruguayFlag from "../assets/images/flags/uy.svg";
import UzbekistanFlag from "../assets/images/flags/uz.svg";
import VanuatuFlag from "../assets/images/flags/vu.svg";
import VaticanCityFlag from "../assets/images/flags/va.svg";
import VenezuelaFlag from "../assets/images/flags/ve.svg";
import VietnamFlag from "../assets/images/flags/vn.svg";
import YemenFlag from "../assets/images/flags/ye.svg";
import ZambiaFlag from "../assets/images/flags/zm.svg";
import ZimbabweFlag from "../assets/images/flags/zw.svg";

const countries = [
  {
    name: "Afghanistan",
    letter: "A",
    flag: AfghanistanFlag,
    capital: "Kabul",
    popularCities: ["Kabul", "Herat", "Kandahar", "Mazar-i-Sharif", "Jalalabad"]
  },
  {
    name: "Albania",
    letter: "A",
    flag: AlbaniaFlag,
    capital: "Tirana",
    popularCities: ["Tirana", "Durrës", "Vlorë", "Shkodër", "Elbasan"]
  },
  {
    name: "Algeria",
    letter: "A",
    flag: AlgeriaFlag,
    capital: "Algiers",
    popularCities: ["Algiers", "Oran", "Constantine", "Annaba", "Blida"]
  },
  {
    name: "Andorra",
    letter: "A",
    flag: AndorraFlag,
    capital: "Andorra la Vella",
    popularCities: [
      "Andorra la Vella",
      "Escaldes-Engordany",
      "Encamp",
      "La Massana",
      "Sant Julià de Lòria"
    ]
  },
  {
    name: "Angola",
    letter: "A",
    flag: AngolaFlag,
    capital: "Luanda",
    popularCities: ["Luanda", "Huambo", "Lobito", "Benguela", "Cabinda"]
  },
  {
    name: "Antigua and Barbuda",
    letter: "A",
    flag: AntiguaAndBarbudaFlag,
    capital: "Saint John's",
    popularCities: [
      "Saint John's",
      "All Saints",
      "Liberta",
      "Bolans",
      "Potters Village"
    ]
  },
  {
    name: "Argentina",
    letter: "A",
    flag: ArgentinaFlag,
    capital: "Buenos Aires",
    popularCities: ["Buenos Aires", "Córdoba", "Rosario", "Mendoza", "La Plata"]
  },
  {
    name: "Armenia",
    letter: "A",
    flag: ArmeniaFlag,
    capital: "Yerevan",
    popularCities: ["Yerevan", "Gyumri", "Vanadzor", "Vagharshapat", "Abovyan"]
  },
  {
    name: "Australia",
    letter: "A",
    flag: AustraliaFlag,
    capital: "Canberra",
    popularCities: ["Canberra", "Sydney", "Melbourne", "Brisbane", "Perth"]
  },
  {
    name: "Austria",
    letter: "A",
    flag: AustriaFlag,
    capital: "Vienna",
    popularCities: ["Vienna", "Graz", "Linz", "Salzburg", "Innsbruck"]
  },
  {
    name: "Azerbaijan",
    letter: "A",
    flag: AzerbaijanFlag,
    capital: "Baku",
    popularCities: ["Baku", "Ganja", "Sumqayit", "Lankaran", "Mingachevir"]
  },
  {
    name: "Bahamas",
    letter: "B",
    flag: BahamasFlag,
    capital: "Nassau",
    popularCities: ["Nassau", "Freeport", "West End", "Coopers Town", "Marsh Harbour"]
  },
  {
    name: "Bahrain",
    letter: "B",
    flag: BahrainFlag,
    capital: "Manama",
    popularCities: ["Manama", "Riffa", "Muharraq", "Hamad Town", "A'ali"]
  },
  {
    name: "Bangladesh",
    letter: "B",
    flag: BangladeshFlag,
    capital: "Dhaka",
    popularCities: ["Dhaka", "Chittagong", "Khulna", "Rajshahi", "Sylhet"]
  },
  {
    name: "Barbados",
    letter: "B",
    flag: BarbadosFlag,
    capital: "Bridgetown",
    popularCities: ["Bridgetown", "Speightstown", "Oistins", "Bathsheba", "Holetown"]
  },
  {
    name: "Belarus",
    letter: "B",
    flag: BelarusFlag,
    capital: "Minsk",
    popularCities: ["Minsk", "Gomel", "Mogilev", "Vitebsk", "Grodno"]
  },
  {
    name: "Belgium",
    letter: "B",
    flag: BelgiumFlag,
    capital: "Brussels",
    popularCities: ["Brussels", "Antwerp", "Ghent", "Charleroi", "Liège"]
  },
  {
    name: "Belize",
    letter: "B",
    flag: BelizeFlag,
    capital: "Belmopan",
    popularCities: ["Belmopan", "Belize City", "San Ignacio", "Orange Walk", "Dangriga"]
  },
  {
    name: "Benin",
    letter: "B",
    flag: BeninFlag,
    capital: "Porto-Novo",
    popularCities: ["Porto-Novo", "Cotonou", "Parakou", "Djougou", "Bohicon"]
  },
  {
    name: "Bhutan",
    letter: "B",
    flag: BhutanFlag,
    capital: "Thimphu",
    popularCities: ["Thimphu", "Phuntsholing", "Punakha", "Samdrup Jongkhar", "Gasa"]
  },
  {
    name: "Bolivia",
    letter: "B",
    flag: BoliviaFlag,
    capital: "Sucre",
    popularCities: ["Sucre", "La Paz", "Santa Cruz", "Cochabamba", "Oruro"]
  },
  {
    name: "Bosnia and Herzegovina",
    letter: "B",
    flag: BosniaAndHerzegovinaFlag,
    capital: "Sarajevo",
    popularCities: ["Sarajevo", "Banja Luka", "Mostar", "Tuzla", "Zenica"]
  },
  {
    name: "Botswana",
    letter: "B",
    flag: BotswanaFlag,
    capital: "Gaborone",
    popularCities: ["Gaborone", "Francistown", "Molepolole", "Maun", "Serowe"]
  },
  {
    name: "Brazil",
    letter: "B",
    flag: BrazilFlag,
    capital: "Brasília",
    popularCities: ["Brasília", "São Paulo", "Rio de Janeiro", "Salvador", "Belo Horizonte"]
  },
  {
    name: "Brunei",
    letter: "B",
    flag: BruneiFlag,
    capital: "Bandar Seri Begawan",
    popularCities: [
      "Bandar Seri Begawan",
      "Kuala Belait",
      "Seria",
      "Tutong",
      "Bangar"
    ]
  },
  {
    name: "Bulgaria",
    letter: "B",
    flag: BulgariaFlag,
    capital: "Sofia",
    popularCities: ["Sofia", "Plovdiv", "Varna", "Burgas", "Ruse"]
  },
  {
    name: "Burkina Faso",
    letter: "B",
    flag: BurkinaFasoFlag,
    capital: "Ouagadougou",
    popularCities: ["Ouagadougou", "Bobo-Dioulasso", "Koudougou", "Banfora", "Ouahigouya"]
  },
  {
    name: "Burundi",
    letter: "B",
    flag: BurundiFlag,
    capital: "Gitega",
    popularCities: ["Gitega", "Bujumbura", "Muyinga", "Ngozi", "Rutana"]
  },
  {
    name: "Cabo Verde",
    letter: "C",
    flag: CaboVerdeFlag,
    capital: "Praia",
    popularCities: ["Praia", "Mindelo", "Santa Maria", "Espargos", "Assomada"]
  },
  {
    name: "Cambodia",
    letter: "C",
    flag: CambodiaFlag,
    capital: "Phnom Penh",
    popularCities: ["Phnom Penh", "Siem Reap", "Battambang", "Sihanoukville", "Kampong Cham"]
  },
  {
    name: "Cameroon",
    letter: "C",
    flag: CameroonFlag,
    capital: "Yaoundé",
    popularCities: ["Yaoundé", "Douala", "Garoua", "Maroua", "Bafoussam"]
  },
  {
    name: "Canada",
    letter: "C",
    flag: CanadaFlag,
    capital: "Ottawa",
    popularCities: ["Ottawa", "Toronto", "Montreal", "Vancouver", "Calgary"]
  },
  {
    name: "Central African Republic",
    letter: "C",
    flag: CentralAfricanRepublicFlag,
    capital: "Bangui",
    popularCities: ["Bangui", "Bimbo", "Berbérati", "Carnot", "Bambari"]
  },
  {
    name: "Chad",
    letter: "C",
    flag: ChadFlag,
    capital: "N'Djamena",
    popularCities: ["N'Djamena", "Moundou", "Sarh", "Abéché", "Kélo"]
  },
  {
    name: "Chile",
    letter: "C",
    flag: ChileFlag,
    capital: "Santiago",
    popularCities: ["Santiago", "Valparaíso", "Concepción", "La Serena", "Antofagasta"]
  },
  {
    name: "China",
    letter: "C",
    flag: ChinaFlag,
    capital: "Beijing",
    popularCities: ["Beijing", "Shanghai", "Guangzhou", "Shenzhen", "Chengdu"]
  },
  {
    name: "Colombia",
    letter: "C",
    flag: ColombiaFlag,
    capital: "Bogotá",
    popularCities: ["Bogotá", "Medellín", "Cali", "Barranquilla", "Cartagena"]
  },
  {
    name: "Comoros",
    letter: "C",
    flag: ComorosFlag,
    capital: "Moroni",
    popularCities: ["Moroni", "Mutsamudu", "Fomboni", "Domoni", "Ouani"]
  },
  {
    name: "Congo",
    letter: "C",
    flag: CongoFlag,
    capital: "Brazzaville",
    popularCities: ["Brazzaville", "Pointe-Noire", "Dolisie", "Kayes", "Owando"]
  },
  {
    name: "Costa Rica",
    letter: "C",
    flag: CostaRicaFlag,
    capital: "San José",
    popularCities: ["San José", "Alajuela", "Cartago", "Puntarenas", "Heredia"]
  },
  {
    name: "Croatia",
    letter: "C",
    flag: CroatiaFlag,
    capital: "Zagreb",
    popularCities: ["Zagreb", "Split", "Rijeka", "Osijek", "Zadar"]
  },
  {
    name: "Cuba",
    letter: "C",
    flag: CubaFlag,
    capital: "Havana",
    popularCities: ["Havana", "Santiago de Cuba", "Camagüey", "Holguín", "Guantánamo"]
  },
  {
    name: "Cyprus",
    letter: "C",
    flag: CyprusFlag,
    capital: "Nicosia",
    popularCities: ["Nicosia", "Limassol", "Larnaca", "Famagusta", "Paphos"]
  },
  {
    name: "Czech Republic",
    letter: "C",
    flag: CzechRepublicFlag,
    capital: "Prague",
    popularCities: ["Prague", "Brno", "Ostrava", "Plzeň", "Olomouc"]
  },
  {
    name: "Denmark",
    letter: "D",
    flag: DenmarkFlag,
    capital: "Copenhagen",
    popularCities: ["Copenhagen", "Aarhus", "Odense", "Aalborg", "Esbjerg"]
  },
  {
    name: "Djibouti",
    letter: "D",
    flag: DjiboutiFlag,
    capital: "Djibouti",
    popularCities: ["Djibouti", "Ali Sabieh", "Tadjourah", "Arta", "Dikhil"]
  },
  {
    name: "Dominica",
    letter: "D",
    flag: DominicaFlag,
    capital: "Roseau",
    popularCities: ["Roseau", "Portsmouth", "Marigot", "Berekua", "Castle Bruce"]
  },
  {
    name: "Dominican Republic",
    letter: "D",
    flag: DominicanRepublicFlag,
    capital: "Santo Domingo",
    popularCities: ["Santo Domingo", "Santiago", "Punta Cana", "La Romana", "Puerto Plata"]
  },
  {
    name: "Ecuador",
    letter: "E",
    flag: EcuadorFlag,
    capital: "Quito",
    popularCities: ["Quito", "Guayaquil", "Cuenca", "Santo Domingo", "Machala"]
  },
  {
    name: "Egypt",
    letter: "E",
    flag: EgyptFlag,
    capital: "Cairo",
    popularCities: ["Cairo", "Alexandria", "Giza", "Shubra El Kheima", "Port Said"]
  },
  {
    name: "El Salvador",
    letter: "E",
    flag: ElSalvadorFlag,
    capital: "San Salvador",
    popularCities: ["San Salvador", "Santa Ana", "Soyapango", "San Miguel", "Mejicanos"]
  },
  {
    name: "Equatorial Guinea",
    letter: "E",
    flag: EquatorialGuineaFlag,
    capital: "Malabo",
    popularCities: ["Malabo", "Bata", "Ebebiyín", "Acurenam", "Luba"]
  },
  {
    name: "Eritrea",
    letter: "E",
    flag: EritreaFlag,
    capital: "Asmara",
    popularCities: ["Asmara", "Keren", "Massawa", "Mendefera", "Assab"]
  },
  {
    name: "Estonia",
    letter: "E",
    flag: EstoniaFlag,
    capital: "Tallinn",
    popularCities: ["Tallinn", "Tartu", "Narva", "Pärnu", "Kohtla-Järve"]
  },
  {
    name: "Eswatini",
    letter: "E",
    flag: EswatiniFlag,
    capital: "Mbabane",
    popularCities: ["Mbabane", "Manzini", "Lobamba", "Nhlangano", "Siteki"]
  },
  {
    name: "Ethiopia",
    letter: "E",
    flag: EthiopiaFlag,
    capital: "Addis Ababa",
    popularCities: ["Addis Ababa", "Dire Dawa", "Mekelle", "Gondar", "Bahir Dar"]
  },
  {
    name: "Fiji",
    letter: "F",
    flag: FijiFlag,
    capital: "Suva",
    popularCities: ["Suva", "Lautoka", "Nadi", "Labasa", "Ba"]
  },
  {
    name: "Finland",
    letter: "F",
    flag: FinlandFlag,
    capital: "Helsinki",
    popularCities: ["Helsinki", "Espoo", "Tampere", "Vantaa", "Oulu"]
  },
  {
    name: "France",
    letter: "F",
    flag: FranceFlag,
    capital: "Paris",
    popularCities: ["Paris", "Marseille", "Lyon", "Toulouse", "Nice"]
  },
  {
    name: "Pakistan",
    letter: "P",
    flag: PakistanFlag,
    capital: "Islamabad",
    founder: "Muhammad Ali Jinnah",
    popularCities: ["Islamabad", "Karachi", "Lahore", "Faisalabad", "Rawalpindi"]
  },
  {
    name: "United States",
    letter: "U",
    flag: UnitedStatesFlag,
    capital: "Washington, D.C.",
    popularCities: [
      "Washington, D.C.",
      "New York",
      "Los Angeles",
      "Chicago",
      "Houston"
    ]
  },
  {
    name: "United Kingdom",
    letter: "U",
    flag: UnitedKingdomFlag,
    capital: "London",
    popularCities: ["London", "Birmingham", "Manchester", "Glasgow", "Liverpool"]
  },
  {
    name: "United Arab Emirates",
    letter: "U",
    flag: UnitedArabEmiratesFlag,
    capital: "Abu Dhabi",
    popularCities: ["Abu Dhabi", "Dubai", "Sharjah", "Al Ain", "Ajman"]
  },
  {
    name: "India",
    letter: "I",
    flag: IndiaFlag,
    capital: "New Delhi",
    popularCities: ["New Delhi", "Mumbai", "Kolkata", "Chennai", "Bengaluru"]
  },
  {
    name: "Saudi Arabia",
    letter: "S",
    flag: SaudiArabiaFlag,
    capital: "Riyadh",
    popularCities: ["Riyadh", "Jeddah", "Mecca", "Medina", "Dammam"]
  },
  {
    name: "Japan",
    letter: "J",
    flag: JapanFlag,
    capital: "Tokyo",
    popularCities: ["Tokyo", "Yokohama", "Osaka", "Nagoya", "Sapporo"]
  },
  {
    name: "Germany",
    letter: "G",
    flag: GermanyFlag,
    capital: "Berlin",
    popularCities: ["Berlin", "Hamburg", "Munich", "Cologne", "Frankfurt"]
  },
  {
    name: "Ghana",
    letter: "G",
    flag: GhanaFlag,
    capital: "Accra",
    popularCities: ["Accra", "Kumasi", "Tamale", "Takoradi", "Ashaiman"]
  },
  {
    name: "Greece",
    letter: "G",
    flag: GreeceFlag,
    capital: "Athens",
    popularCities: ["Athens", "Thessaloniki", "Patras", "Heraklion", "Larissa"]
  },
  {
    name: "Grenada",
    letter: "G",
    flag: GrenadaFlag,
    capital: "St. George's",
    popularCities: [
      "St. George's",
      "Gouyave",
      "Grenville",
      "Victoria",
      "Sauteurs"
    ]
  },
  {
    name: "Guatemala",
    letter: "G",
    flag: GuatemalaFlag,
    capital: "Guatemala City",
    popularCities: [
      "Guatemala City",
      "Mixco",
      "Villa Nueva",
      "Petapa",
      "San Juan Sacatepéquez"
    ]
  },
  {
    name: "Guinea",
    letter: "G",
    flag: GuineaFlag,
    capital: "Conakry",
    popularCities: ["Conakry", "Nzérékoré", "Kankan", "Kindia", "Labé"]
  },
  {
    name: "Guinea-Bissau",
    letter: "G",
    flag: GuineaBissauFlag,
    capital: "Bissau",
    popularCities: ["Bissau", "Bafatá", "Gabú", "Canchungo", "Cacheu"]
  },
  {
    name: "Guyana",
    letter: "G",
    flag: GuyanaFlag,
    capital: "Georgetown",
    popularCities: ["Georgetown", "Linden", "New Amsterdam", "Anna Regina", "Bartica"]
  },
  {
    name: "Haiti",
    letter: "H",
    flag: HaitiFlag,
    capital: "Port-au-Prince",
    popularCities: [
      "Port-au-Prince",
      "Cap-Haïtien",
      "Carrefour",
      "Delmas",
      "Pétionville"
    ]
  },
  {
    name: "Honduras",
    letter: "H",
    flag: HondurasFlag,
    capital: "Tegucigalpa",
    popularCities: [
      "Tegucigalpa",
      "San Pedro Sula",
      "Choloma",
      "La Ceiba",
      "El Progreso"
    ]
  },
  {
    name: "Hungary",
    letter: "H",
    flag: HungaryFlag,
    capital: "Budapest",
    popularCities: ["Budapest", "Debrecen", "Szeged", "Miskolc", "Pécs"]
  },
  {
    name: "Iceland",
    letter: "I",
    flag: IcelandFlag,
    capital: "Reykjavík",
    popularCities: ["Reykjavík", "Kópavogur", "Hafnarfjörður", "Akureyri", "Reykjanesbær"]
  },
  {
    name: "Indonesia",
    letter: "I",
    flag: IndonesiaFlag,
    capital: "Jakarta",
    popularCities: ["Jakarta", "Surabaya", "Bandung", "Medan", "Semarang"]
  },
  {
    name: "Iran",
    letter: "I",
    flag: IranFlag,
    capital: "Tehran",
    popularCities: ["Tehran", "Mashhad", "Isfahan", "Karaj", "Shiraz"]
  },
  {
    name: "Iraq",
    letter: "I",
    flag: IraqFlag,
    capital: "Baghdad",
    popularCities: ["Baghdad", "Basra", "Mosul", "Erbil", "Kirkuk"]
  },
  {
    name: "Ireland",
    letter: "I",
    flag: IrelandFlag,
    capital: "Dublin",
    popularCities: ["Dublin", "Cork", "Limerick", "Galway", "Waterford"]
  },
  {
    name: "Israel",
    letter: "I",
    flag: IsraelFlag,
    capital: "Jerusalem",
    popularCities: ["Jerusalem", "Tel Aviv", "Haifa", "Rishon LeZion", "Petah Tikva"]
  },
  {
    name: "Italy",
    letter: "I",
    flag: ItalyFlag,
    capital: "Rome",
    popularCities: ["Rome", "Milan", "Naples", "Turin", "Palermo"]
  },
  {
    name: "Jamaica",
    letter: "J",
    flag: JamaicaFlag,
    capital: "Kingston",
    popularCities: ["Kingston", "Montego Bay", "Spanish Town", "Portmore", "Mandeville"]
  },
  {
    name: "Jordan",
    letter: "J",
    flag: JordanFlag,
    capital: "Amman",
    popularCities: ["Amman", "Zarqa", "Irbid", "Russeifa", "Aqaba"]
  },
  {
    name: "Kazakhstan",
    letter: "K",
    flag: KazakhstanFlag,
    capital: "Astana",
    popularCities: ["Astana", "Almaty", "Shymkent", "Karaganda", "Aktobe"]
  },
  {
    name: "Kenya",
    letter: "K",
    flag: KenyaFlag,
    capital: "Nairobi",
    popularCities: ["Nairobi", "Mombasa", "Kisumu", "Nakuru", "Eldoret"]
  },
  {
    name: "Kiribati",
    letter: "K",
    flag: KiribatiFlag,
    capital: "Tarawa",
    popularCities: ["Tarawa", "Betio", "Bikenibeu", "Teaoraereke", "Buariki"]
  },
  {
    name: "Korea, North",
    letter: "K",
    flag: KoreaNorthFlag,
    capital: "Pyongyang",
    popularCities: ["Pyongyang", "Hamhung", "Chongjin", "Nampo", "Wonsan"]
  },
  {
    name: "Korea, South",
    letter: "K",
    flag: KoreaSouthFlag,
    capital: "Seoul",
    popularCities: ["Seoul", "Busan", "Incheon", "Daegu", "Daejeon"]
  },
  {
    name: "Kosovo",
    letter: "K",
    flag: KosovoFlag,
    capital: "Pristina",
    popularCities: ["Pristina", "Prizren", "Peja", "Gjakova", "Gjilan"]
  },
  {
    name: "Kuwait",
    letter: "K",
    flag: KuwaitFlag,
    capital: "Kuwait City",
    popularCities: [
      "Kuwait City",
      "Al Ahmadi",
      "Hawalli",
      "Salmiya",
      "Al Farwaniyah"
    ]
  },
  {
    name: "Kyrgyzstan",
    letter: "K",
    flag: KyrgyzstanFlag,
    capital: "Bishkek",
    popularCities: ["Bishkek", "Osh", "Jalal-Abad", "Karakol", "Tokmok"]
  },
  {
    name: "Laos",
    letter: "L",
    flag: LaosFlag,
    capital: "Vientiane",
    popularCities: ["Vientiane", "Savannakhet", "Luang Prabang", "Pakse", "Xam Neua"]
  },
  {
    name: "Latvia",
    letter: "L",
    flag: LatviaFlag,
    capital: "Riga",
    popularCities: ["Riga", "Daugavpils", "Liepāja", "Jelgava", "Jūrmala"]
  },
  {
    name: "Lebanon",
    letter: "L",
    flag: LebanonFlag,
    capital: "Beirut",
    popularCities: ["Beirut", "Tripoli", "Sidon", "Tyre", "Byblos"]
  },
  {
    name: "Lesotho",
    letter: "L",
    flag: LesothoFlag,
    capital: "Maseru",
    popularCities: ["Maseru", "Teyateyaneng", "Mafeteng", "Hlotse", "Mohale's Hoek"]
  },
  {
    name: "Liberia",
    letter: "L",
    flag: LiberiaFlag,
    capital: "Monrovia",
    popularCities: ["Monrovia", "Gbarnga", "Buchanan", "Ganta", "Kakata"]
  },
  {
    name: "Libya",
    letter: "L",
    flag: LibyaFlag,
    capital: "Tripoli",
    popularCities: ["Tripoli", "Benghazi", "Misrata", "Bayda", "Zawiya"]
  },
  {
    name: "Liechtenstein",
    letter: "L",
    flag: LiechtensteinFlag,
    capital: "Vaduz",
    popularCities: ["Vaduz", "Schaan", "Triesen", "Balzers", "Eschen"]
  },
  {
    name: "Lithuania",
    letter: "L",
    flag: LithuaniaFlag,
    capital: "Vilnius",
    popularCities: ["Vilnius", "Kaunas", "Klaipėda", "Šiauliai", "Panevėžys"]
  },
  {
    name: "Luxembourg",
    letter: "L",
    flag: LuxembourgFlag,
    capital: "Luxembourg City",
    popularCities: [
      "Luxembourg City",
      "Esch-sur-Alzette",
      "Dudelange",
      "Differdange",
      "Strassen"
    ]
  },
  {
    name: "Madagascar",
    letter: "M",
    flag: MadagascarFlag,
    capital: "Antananarivo",
    popularCities: [
      "Antananarivo",
      "Toamasina",
      "Antsirabe",
      "Mahajanga",
      "Fianarantsoa"
    ]
  },
  {
    name: "Malawi",
    letter: "M",
    flag: MalawiFlag,
    capital: "Lilongwe",
    popularCities: ["Lilongwe", "Blantyre", "Mzuzu", "Zomba", "Kasungu"]
  },
  {
    name: "Malaysia",
    letter: "M",
    flag: MalaysiaFlag,
    capital: "Kuala Lumpur",
    popularCities: ["Kuala Lumpur", "George Town", "Johor Bahru", "Ipoh", "Kuching"]
  },
  {
    name: "Maldives",
    letter: "M",
    flag: MaldivesFlag,
    capital: "Malé",
    popularCities: ["Malé", "Addu City", "Fuvahmulah", "Kulhudhuffushi", "Thinadhoo"]
  },
  {
    name: "Mali",
    letter: "M",
    flag: MaliFlag,
    capital: "Bamako",
    popularCities: ["Bamako", "Ségou", "Sikasso", "Mopti", "Koutiala"]
  },
  {
    name: "Malta",
    letter: "M",
    flag: MaltaFlag,
    capital: "Valletta",
    popularCities: ["Valletta", "Birkirkara", "Qormi", "Mosta", "Żabbar"]
  },
  {
    name: "Marshall Islands",
    letter: "M",
    flag: MarshallIslandsFlag,
    capital: "Majuro",
    popularCities: ["Majuro", "Ebeye", "Jaluit", "Wotje", "Arno"]
  },
  {
    name: "Mauritania",
    letter: "M",
    flag: MauritaniaFlag,
    capital: "Nouakchott",
    popularCities: ["Nouakchott", "Nouadhibou", "Kiffa", "Kaédi", "Rosso"]
  },
  {
    name: "Mauritius",
    letter: "M",
    flag: MauritiusFlag,
    capital: "Port Louis",
    popularCities: [
      "Port Louis",
      "Curepipe",
      "Vacoas",
      "Port Mathurin",
      "Quatre Bornes"
    ]
  },
  {
    name: "Mexico",
    letter: "M",
    flag: MexicoFlag,
    capital: "Mexico City",
    popularCities: [
      "Mexico City",
      "Guadalajara",
      "Monterrey",
      "Puebla",
      "Tijuana"
    ]
  },
  {
    name: "Micronesia",
    letter: "M",
    flag: MicronesiaFlag,
    capital: "Palikir",
    popularCities: ["Palikir", "Weno", "Tofol", "Kolonia", "Chuuk"]
  },
  {
    name: "Moldova",
    letter: "M",
    flag: MoldovaFlag,
    capital: "Chișinău",
    popularCities: ["Chișinău", "Tiraspol", "Bălți", "Bender", "Cahul"]
  },
  {
    name: "Monaco",
    letter: "M",
    flag: MonacoFlag,
    capital: "Monaco",
    popularCities: [
      "Monaco",
      "Monte Carlo",
      "La Condamine",
      "Fontvieille",
      "Moneghetti"
    ]
  },
  {
    name: "Mongolia",
    letter: "M",
    flag: MongoliaFlag,
    capital: "Ulaanbaatar",
    popularCities: [
      "Ulaanbaatar",
      "Erdenet",
      "Darkhan",
      "Choibalsan",
      "Mörön"
    ]
  },
  {
    name: "Montenegro",
    letter: "M",
    flag: MontenegroFlag,
    capital: "Podgorica",
    popularCities: ["Podgorica", "Nikšić", "Pljevlja", "Bijelo Polje", "Cetinje"]
  },
  {
    name: "Morocco",
    letter: "M",
    flag: MoroccoFlag,
    capital: "Rabat",
    popularCities: ["Rabat", "Casablanca", "Fes", "Marrakesh", "Tangier"]
  },
  {
    name: "Mozambique",
    letter: "M",
    flag: MozambiqueFlag,
    capital: "Maputo",
    popularCities: ["Maputo", "Beira", "Nampula", "Chimoio", "Quelimane"]
  },
  {
    name: "Myanmar",
    letter: "M",
    flag: MyanmarFlag,
    capital: "Naypyidaw",
    popularCities: ["Naypyidaw", "Yangon", "Mandalay", "Mawlamyine", "Bago"]
  },
  {
    name: "Namibia",
    letter: "N",
    flag: NamibiaFlag,
    capital: "Windhoek",
    popularCities: ["Windhoek", "Walvis Bay", "Swakopmund", "Oshakati", "Rundu"]
  },
  {
    name: "Nauru",
    letter: "N",
    flag: NauruFlag,
    capital: "Yaren",
    popularCities: ["Yaren", "Denigomodu", "Aiwo", "Anabar", "Baiti"]
  },
  {
    name: "Nepal",
    letter: "N",
    flag: NepalFlag,
    capital: "Kathmandu",
    popularCities: ["Kathmandu", "Pokhara", "Lalitpur", "Biratnagar", "Birgunj"]
  },
  {
    name: "Netherlands",
    letter: "N",
    flag: NetherlandsFlag,
    capital: "Amsterdam",
    popularCities: ["Amsterdam", "Rotterdam", "The Hague", "Utrecht", "Eindhoven"]
  },
  {
    name: "New Zealand",
    letter: "N",
    flag: NewZealandFlag,
    capital: "Wellington",
    popularCities: ["Wellington", "Auckland", "Christchurch", "Hamilton", "Dunedin"]
  },
  {
    name: "Nicaragua",
    letter: "N",
    flag: NicaraguaFlag,
    capital: "Managua",
    popularCities: ["Managua", "León", "Masaya", "Tipitapa", "Chinandega"]
  },
  {
    name: "Niger",
    letter: "N",
    flag: NigerFlag,
    capital: "Niamey",
    popularCities: ["Niamey", "Zinder", "Maradi", "Agadez", "Tahoua"]
  },
  {
    name: "Nigeria",
    letter: "N",
    flag: NigeriaFlag,
    capital: "Abuja",
    popularCities: ["Abuja", "Lagos", "Kano", "Ibadan", "Port Harcourt"]
  },
  {
    name: "North Macedonia",
    letter: "N",
    flag: NorthMacedoniaFlag,
    capital: "Skopje",
    popularCities: ["Skopje", "Bitola", "Kumanovo", "Prilep", "Tetovo"]
  },
  {
    name: "Norway",
    letter: "N",
    flag: NorwayFlag,
    capital: "Oslo",
    popularCities: ["Oslo", "Bergen", "Trondheim", "Stavanger", "Drammen"]
  },
  {
    name: "Oman",
    letter: "O",
    flag: OmanFlag,
    capital: "Muscat",
    popularCities: ["Muscat", "Seeb", "Salalah", "Bawshar", "Sohar"]
  },
  {
    name: "Pakistan",
    letter: "P",
    flag: PakistanFlag,
    capital: "Islamabad",
    popularCities: ["Islamabad", "Karachi", "Lahore", "Faisalabad", "Peshawar"]
  },
  {
    name: "Palau",
    letter: "P",
    flag: PalauFlag,
    capital: "Ngerulmud",
    popularCities: ["Ngerulmud", "Koror", "Airai", "Peleliu", "Angaur"]
  },
  {
    name: "Panama",
    letter: "P",
    flag: PanamaFlag,
    capital: "Panama City",
    popularCities: [
      "Panama City",
      "San Miguelito",
      "Tocumen",
      "David",
      "La Chorrera"
    ]
  },
  {
    name: "Papua New Guinea",
    letter: "P",
    flag: PapuaNewGuineaFlag,
    capital: "Port Moresby",
    popularCities: [
      "Port Moresby",
      "Lae",
      "Mount Hagen",
      "Madang",
      "Kokopo"
    ]
  },
  {
    name: "Paraguay",
    letter: "P",
    flag: ParaguayFlag,
    capital: "Asunción",
    popularCities: ["Asunción", "Ciudad del Este", "San Lorenzo", "Luque", "Encarnación"]
  },
  {
    name: "Peru",
    letter: "P",
    flag: PeruFlag,
    capital: "Lima",
    popularCities: ["Lima", "Arequipa", "Trujillo", "Chiclayo", "Piura"]
  },
  {
    name: "Philippines",
    letter: "P",
    flag: PhilippinesFlag,
    capital: "Manila",
    popularCities: ["Manila", "Quezon City", "Davao", "Cebu City", "Zamboanga"]
  },
  {
    name: "Poland",
    letter: "P",
    flag: PolandFlag,
    capital: "Warsaw",
    popularCities: ["Warsaw", "Kraków", "Łódź", "Wrocław", "Poznań"]
  },
  {
    name: "Portugal",
    letter: "P",
    flag: PortugalFlag,
    capital: "Lisbon",
    popularCities: ["Lisbon", "Porto", "Vila Nova de Gaia", "Amadora", "Braga"]
  },
  {
    name: "Qatar",
    letter: "Q",
    flag: QatarFlag,
    capital: "Doha",
    popularCities: ["Doha", "Al Rayyan", "Al Wakrah", "Al Khor", "Al Shamal"]
  },
  {
    name: "Romania",
    letter: "R",
    flag: RomaniaFlag,
    capital: "Bucharest",
    popularCities: ["Bucharest", "Cluj-Napoca", "Timișoara", "Iași", "Constanța"]
  },
  {
    name: "Russia",
    letter: "R",
    flag: RussiaFlag,
    capital: "Moscow",
    popularCities: ["Moscow", "Saint Petersburg", "Novosibirsk", "Yekaterinburg", "Nizhny Novgorod"]
  },
  {
    name: "Rwanda",
    letter: "R",
    flag: RwandaFlag,
    capital: "Kigali",
    popularCities: ["Kigali", "Butare", "Gitarama", "Ruhengeri", "Gisenyi"]
  },
  {
    name: "Saint Kitts and Nevis",
    letter: "S",
    flag: SaintKittsAndNevisFlag,
    capital: "Basseterre",
    popularCities: ["Basseterre", "Sandy Point Town", "Cayon", "Charlestown", "Dieppe Bay Town"]
  },
  {
    name: "Saint Lucia",
    letter: "S",
    flag: SaintLuciaFlag,
    capital: "Castries",
    popularCities: ["Castries", "Vieux Fort", "Soufrière", "Gros Islet", "Micoud"]
  },
  {
    name: "Saint Vincent and the Grenadines",
    letter: "S",
    flag: SaintVincentAndTheGrenadinesFlag,
    capital: "Kingstown",
    popularCities: [
      "Kingstown",
      "Georgetown",
      "Barrouallie",
      "Chateaubelair",
      "Layou"
    ]
  },
  {
    name: "Samoa",
    letter: "S",
    flag: SamoaFlag,
    capital: "Apia",
    popularCities: ["Apia", "Vaitele", "Faleula", "Siusega", "Malie"]
  },
  {
    name: "San Marino",
    letter: "S",
    flag: SanMarinoFlag,
    capital: "San Marino",
    popularCities: [
      "San Marino",
      "Borgo Maggiore",
      "Serravalle",
      "Domagnano",
      "Faetano"
    ]
  },
  {
    name: "Sao Tome and Principe",
    letter: "S",
    flag: SaoTomeAndPrincipeFlag,
    capital: "São Tomé",
    popularCities: ["São Tomé", "Santo Amaro", "Neves", "Santana", "Trindade"]
  },
  {
    name: "Saudi Arabia",
    letter: "S",
    flag: SaudiArabiaFlag,
    capital: "Riyadh",
    popularCities: ["Riyadh", "Jeddah", "Mecca", "Medina", "Dammam"]
  },
  {
    name: "Senegal",
    letter: "S",
    flag: SenegalFlag,
    capital: "Dakar",
    popularCities: ["Dakar", "Touba", "Thiès", "Rufisque", "Kaolack"]
  },
  {
    name: "Serbia",
    letter: "S",
    flag: SerbiaFlag,
    capital: "Belgrade",
    popularCities: ["Belgrade", "Novi Sad", "Niš", "Kragujevac", "Subotica"]
  },
  {
    name: "Seychelles",
    letter: "S",
    flag: SeychellesFlag,
    capital: "Victoria",
    popularCities: ["Victoria", "Anse Boileau", "Bel Ombre", "Beau Vallon", "Cascade"]
  },
  {
    name: "Sierra Leone",
    letter: "S",
    flag: SierraLeoneFlag,
    capital: "Freetown",
    popularCities: ["Freetown", "Bo", "Kenema", "Makeni", "Koidu"]
  },
  {
    name: "Singapore",
    letter: "S",
    flag: SingaporeFlag,
    capital: "Singapore",
    popularCities: ["Singapore", "Woodlands", "Jurong East", "Toa Payoh", "Tampines"]
  },
  {
    name: "Slovakia",
    letter: "S",
    flag: SlovakiaFlag,
    capital: "Bratislava",
    popularCities: ["Bratislava", "Košice", "Prešov", "Žilina", "Banská Bystrica"]
  },
  {
    name: "Slovenia",
    letter: "S",
    flag: SloveniaFlag,
    capital: "Ljubljana",
    popularCities: ["Ljubljana", "Maribor", "Celje", "Kranj", "Velenje"]
  },
  {
    name: "Solomon Islands",
    letter: "S",
    flag: SolomonIslandsFlag,
    capital: "Honiara",
    popularCities: ["Honiara", "Gizo", "Auki", "Taro", "Buala"]
  },
  {
    name: "Somalia",
    letter: "S",
    flag: SomaliaFlag,
    capital: "Mogadishu",
    popularCities: ["Mogadishu", "Hargeisa", "Bosaso", "Kismayo", "Baidoa"]
  },
  {
    name: "South Africa",
    letter: "S",
    flag: SouthAfricaFlag,
    capital: "Pretoria",
    popularCities: ["Pretoria", "Johannesburg", "Cape Town", "Durban", "Soweto"]
  },
  {
    name: "South Sudan",
    letter: "S",
    flag: SouthSudanFlag,
    capital: "Juba",
    popularCities: ["Juba", "Malakal", "Wau", "Yambio", "Rumbek"]
  },
  {
    name: "Spain",
    letter: "S",
    flag: SpainFlag,
    capital: "Madrid",
    popularCities: ["Madrid", "Barcelona", "Valencia", "Seville", "Zaragoza"]
  },
  {
    name: "Sri Lanka",
    letter: "S",
    flag: SriLankaFlag,
    capital: "Sri Jayawardenepura Kotte",
    popularCities: [
      "Sri Jayawardenepura Kotte",
      "Colombo",
      "Kandy",
      "Galle",
      "Jaffna"
    ]
  },
  {
    name: "Sudan",
    letter: "S",
    flag: SudanFlag,
    capital: "Khartoum",
    popularCities: ["Khartoum", "Omdurman", "Port Sudan", "Nyala", "Kassala"]
  },
  {
    name: "Suriname",
    letter: "S",
    flag: SurinameFlag,
    capital: "Paramaribo",
    popularCities: ["Paramaribo", "Lelydorp", "Nieuw Nickerie", "Moengo", "Mariënburg"]
  },
  {
    name: "Sweden",
    letter: "S",
    flag: SwedenFlag,
    capital: "Stockholm",
    popularCities: ["Stockholm", "Gothenburg", "Malmö", "Uppsala", "Västerås"]
  },
  {
    name: "Switzerland",
    letter: "S",
    flag: SwitzerlandFlag,
    capital: "Bern",
    popularCities: ["Bern", "Zurich", "Geneva", "Basel", "Lausanne"]
  },
  {
    name: "Syria",
    letter: "S",
    flag: SyriaFlag,
    capital: "Damascus",
    popularCities: ["Damascus", "Aleppo", "Homs", "Hama", "Latakia"]
  },
  {
    name: "Taiwan",
    letter: "T",
    flag: TaiwanFlag,
    capital: "Taipei",
    popularCities: ["Taipei", "Kaohsiung", "Taichung", "Tainan", "Taoyuan"]
  },
  {
    name: "Tajikistan",
    letter: "T",
    flag: TajikistanFlag,
    capital: "Dushanbe",
    popularCities: ["Dushanbe", "Khujand", "Kulob", "Qurghonteppa", "Istaravshan"]
  },
  {
    name: "Tanzania",
    letter: "T",
    flag: TanzaniaFlag,
    capital: "Dodoma",
    popularCities: ["Dodoma", "Dar es Salaam", "Mwanza", "Arusha", "Mbeya"]
  },
  {
    name: "Thailand",
    letter: "T",
    flag: ThailandFlag,
    capital: "Bangkok",
    popularCities: ["Bangkok", "Chiang Mai", "Nonthaburi", "Nakhon Ratchasima", "Udon Thani"]
  },
  {
    name: "Togo",
    letter: "T",
    flag: TogoFlag,
    capital: "Lomé",
    popularCities: ["Lomé", "Sokodé", "Kara", "Atakpamé", "Dapaong"]
  },
  {
    name: "Tonga",
    letter: "T",
    flag: TongaFlag,
    capital: "Nukuʻalofa",
    popularCities: ["Nukuʻalofa", "Neiafu", "Haveluloto", "Vaini", "Pangai"]
  },
  {
    name: "Trinidad and Tobago",
    letter: "T",
    flag: TrinidadAndTobagoFlag,
    capital: "Port of Spain",
    popularCities: [
      "Port of Spain",
      "Chaguanas",
      "San Fernando",
      "Arima",
      "Point Fortin"
    ]
  },
  {
    name: "Tunisia",
    letter: "T",
    flag: TunisiaFlag,
    capital: "Tunis",
    popularCities: ["Tunis", "Sfax", "Sousse", "Ettadhamen", "Kairouan"]
  },
  {
    name: "Turkey",
    letter: "T",
    flag: TurkeyFlag,
    capital: "Ankara",
    popularCities: ["Ankara", "Istanbul", "Izmir", "Bursa", "Adana"]
  },
  {
    name: "Turkmenistan",
    letter: "T",
    flag: TurkmenistanFlag,
    capital: "Ashgabat",
    popularCities: ["Ashgabat", "Türkmenabat", "Daşoguz", "Mary", "Balkanabat"]
  },
  {
    name: "Tuvalu",
    letter: "T",
    flag: TuvaluFlag,
    capital: "Funafuti",
    popularCities: ["Funafuti", "Savave", "Asau", "Tanrake", "Toga"]
  },
  {
    name: "Uganda",
    letter: "U",
    flag: UgandaFlag,
    capital: "Kampala",
    popularCities: ["Kampala", "Gulu", "Lira", "Mbarara", "Jinja"]
  },
  {
    name: "Ukraine",
    letter: "U",
    flag: UkraineFlag,
    capital: "Kyiv",
    popularCities: ["Kyiv", "Kharkiv", "Odessa", "Dnipro", "Donetsk"]
  },
  {
    name: "Uruguay",
    letter: "U",
    flag: UruguayFlag,
    capital: "Montevideo",
    popularCities: ["Montevideo", "Salto", "Paysandú", "Las Piedras", "Rivera"]
  },
  {
    name: "Uzbekistan",
    letter: "U",
    flag: UzbekistanFlag,
    capital: "Tashkent",
    popularCities: ["Tashkent", "Samarkand", "Bukhara", "Namangan", "Andijan"]
  },
  {
    name: "Vanuatu",
    letter: "V",
    flag: VanuatuFlag,
    capital: "Port Vila",
    popularCities: ["Port Vila", "Luganville", "Norsup", "Isangel", "Lenakel"]
  },
  {
    name: "Vatican City",
    letter: "V",
    flag: VaticanCityFlag,
    capital: "Vatican City",
    popularCities: [
      "Vatican City",
      "St. Peter's Basilica",
      "Sistine Chapel",
      "Apostolic Palace",
      "Vatican Museums"
    ]
  },
  {
    name: "Venezuela",
    letter: "V",
    flag: VenezuelaFlag,
    capital: "Caracas",
    popularCities: ["Caracas", "Maracaibo", "Valencia", "Barquisimeto", "Maracay"]
  },
  {
    name: "Vietnam",
    letter: "V",
    flag: VietnamFlag,
    capital: "Hanoi",
    popularCities: ["Hanoi", "Ho Chi Minh City", "Da Nang", "Hai Phong", "Can Tho"]
  },
  {
    name: "Yemen",
    letter: "Y",
    flag: YemenFlag,
    capital: "Sana'a",
    popularCities: ["Sana'a", "Aden", "Ta'izz", "Al Hudaydah", "Ibb"]
  },
  {
    name: "Zambia",
    letter: "Z",
    flag: ZambiaFlag,
    capital: "Lusaka",
    popularCities: ["Lusaka", "Kitwe", "Ndola", "Kabwe", "Chingola"]
  },
  {
    name: "Zimbabwe",
    letter: "Z",
    flag: ZimbabweFlag,
    capital: "Harare",
    popularCities: ["Harare", "Bulawayo", "Chitungwiza", "Mutare", "Gweru"]
  }
];


export default countries;
